import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "preview", "placeholder", "removeBtn"]

    connect() {
        this.checkState()
    }

    trigger(event) {
        // Prevent infinite loop if the input click bubbles up
        if (event.target === this.inputTarget) return
        if (event.target.closest('[data-action="click->image-upload#remove"]')) return

        event.preventDefault()
        this.inputTarget.click()
    }

    handleFileSelect(event) {
        const input = event.target
        if (input.files && input.files[0]) {
            this.displayPreview(input.files[0])
        }
    }

    handleDragOver(event) {
        event.preventDefault()
        this.element.classList.add("border-indigo-500", "bg-indigo-900/20")
    }

    handleDragLeave(event) {
        event.preventDefault()
        this.element.classList.remove("border-indigo-500", "bg-indigo-900/20")
    }

    handleDrop(event) {
        event.preventDefault()
        this.element.classList.remove("border-indigo-500", "bg-indigo-900/20")

        if (event.dataTransfer.files && event.dataTransfer.files[0]) {
            this.inputTarget.files = event.dataTransfer.files
            this.displayPreview(event.dataTransfer.files[0])
        }
    }

    displayPreview(file) {
        const reader = new FileReader()
        reader.onload = (e) => {
            this.previewTarget.src = e.target.result
            this.element.setAttribute("data-has-image", "true")
            this.checkState()
        }
        reader.readAsDataURL(file)
    }

    remove(event) {
        event.stopPropagation()
        event.preventDefault()
        this.inputTarget.value = ""
        this.previewTarget.src = ""
        this.element.removeAttribute("data-has-image")
        this.checkState()
    }

    checkState() {
        const hasImage = this.element.hasAttribute("data-has-image") || this.previewTarget.getAttribute("src").length > 0

        if (hasImage) {
            this.previewTarget.classList.remove("hidden")
            if (this.hasPlaceholderTarget) this.placeholderTarget.classList.add("hidden")
            if (this.hasRemoveBtnTarget) this.removeBtnTarget.classList.remove("hidden")
        } else {
            this.previewTarget.classList.add("hidden")
            if (this.hasPlaceholderTarget) this.placeholderTarget.classList.remove("hidden")
            if (this.hasRemoveBtnTarget) this.removeBtnTarget.classList.add("hidden")
        }
    }
}
